<template>
    <div class="applied-filters">
        <div class="btn show-applied-filters-button">
            <i class="fas fa-filter" />
            {{ filtersLength ? `(${filtersLength})` : '' }}
        </div>
        <div class="applied-filters-list card">
            <div v-if="filtersLength" class="card-body">
                <span
                    v-for="(value, key) in filters"
                    :key="key"
                    class="applied-filter"
                >
                    <span>{{ value.text }}</span>
                    {{ getFilterText(value) }}
                </span>
            </div>
            <div v-else class="card-body">
                No filters applied
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    data() {
        return {
            prefixes: {
                substring: 'contains',
                endsWith: 'ends with',
                startsWith: 'starts with',
                eq: 'is',
                not: 'is not',
                gt: 'greater than',
                gte: 'greater or equal than',
                lt: 'less than',
                lte: 'less or equal than',
                between: 'between',
                notBetween: 'not between',
                in: 'is one of'
            }
        };
    },

    computed: {
        filtersLength() {
            return Object.keys(this.filters).length;
        }
    },

    methods: {
        getFilterText(filter) {
            const { type, fieldType } = filter;
            let { value } = filter;

            if (fieldType === 'boolean') {
                value = value ? 'active' : 'inactive';
            } else if (Array.isArray(value)) {
                value = value.join(', ');
            } else {
                value = `"${value}"`;
            }

            return `${this.prefixes[type]} ${value}`;
        }
    }
};
</script>
